import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const FAQ_ITEMS = [
  {
    q: "Qu'est-ce que PulseCIO ?",
    a: "PulseCIO est une plateforme SaaS de communication et gouvernance IT pour DSI, CIO Office et PMO. Elle centralise messages professionnels, gestion de tâches, notifications et conformité dans un seul outil sécurisé.",
  },
  {
    q: "Quels sont les plans et tarifs disponibles ?",
    a: "PulseCIO propose 5 plans : Free (gratuit, 1 utilisateur), Starter (7,99\u20ac/mois, 10 utilisateurs), Team (14,99\u20ac/mois, 30 utilisateurs), Business (24,99\u20ac/mois, 50 utilisateurs) et Enterprise (49,99\u20ac/mois, utilisateurs illimités avec support dédié 24/7).",
  },
  {
    q: "PulseCIO est-il conforme RGPD ?",
    a: "Oui, PulseCIO est conforme RGPD. Les données sont stockées de manière sécurisée, chaque organisation bénéficie d'une isolation complète (multi-tenant), et la plateforme intègre des fonctionnalités d'audit et de traitement conforme des données personnelles.",
  },
  {
    q: "Puis-je annuler mon abonnement ?",
    a: "Oui, vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre organisation. Votre accès reste actif jusqu'à la fin de la période payée.",
  },
  {
    q: "PulseCIO remplace-t-il Notion, ClickUp ou Confluence ?",
    a: "Oui, PulseCIO est conçu pour remplacer plusieurs outils en un seul : bibliothèque de messages (Notion/Confluence), gestion de tâches (ClickUp), notifications et communication interne. Cela représente des économies de 262\u20ac à 2475\u20ac/mois selon la taille de votre organisation.",
  },
  {
    q: "Comment contacter le support PulseCIO ?",
    a: "Vous pouvez contacter le support par email à contact@pulsecio.com. Les délais varient selon votre plan : communauté (Free), 48h (Starter), 24h (Team), prioritaire (Business), dédié 24/7 (Enterprise).",
  },
  {
    q: "PulseCIO convient-il aux PME, associations et particuliers ?",
    a: "Oui, PulseCIO est conçu pour toutes les organisations : DSI et CIO Office pour la gouvernance IT, PME pour la communication interne et la gestion de tâches, associations pour la coordination d'équipe, et particuliers pour organiser messages et rappels. Chaque plan est calibré selon la taille et les besoins, de 1 à plusieurs centaines d'utilisateurs.",
  },
  {
    q: "Comment fonctionne la sécurité et le chiffrement des données sur PulseCIO ?",
    a: "PulseCIO utilise un chiffrement AES-256-GCM de niveau militaire pour toutes les données sensibles (emails, noms, messages, todos). Chaque organisation bénéficie d'une isolation complète des données (multi-tenant). La plateforme intègre un journal d'audit, un historique immuable des actions, et est entièrement conforme RGPD.",
  },
  {
    q: "Puis-je tester PulseCIO gratuitement ?",
    a: "Oui, le plan Free est disponible sans limite de durée pour 1 utilisateur avec 30 messages et 15 todos. Aucune carte bancaire requise. Vous pouvez upgrader vers un plan payant à tout moment depuis les paramètres de votre organisation.",
  },
];

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  return (
    <section id="faq" className="py-20" aria-label="Questions fréquentes">
      <h2 className="text-3xl font-bold mb-4">Questions fréquentes sur PulseCIO</h2>
      <p className="text-gray-600 dark:text-gray-300 mb-2">
        Tout ce que vous devez savoir sur la plateforme SaaS de communication IT, gestion de tâches et gouvernance — avant de démarrer.
      </p>
      <p className="text-gray-500 dark:text-gray-400 text-sm mb-10">
        PulseCIO est l'alternative à Notion, ClickUp et Confluence pour les DSI, CIO Office, PME, associations et particuliers. Conformité RGPD, chiffrement AES-256, multi-tenant — essai gratuit sans carte bancaire.
      </p>

      <div className="flex flex-col gap-3">
        {FAQ_ITEMS.map((item, i) => {
          const isOpen = openIdx === i;
          return (
            <div
              key={i}
              className={`border rounded-lg bg-white dark:bg-gray-800 overflow-hidden transition-all duration-200 ${
                isOpen
                  ? 'border-blue-400 dark:border-blue-500 ring-1 ring-blue-200 dark:ring-blue-600'
                  : 'border-gray-200 dark:border-gray-700'
              }`}
            >
              <button
                onClick={() => toggle(i)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left font-semibold text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
              >
                <span>{item.q}</span>
                <FiChevronDown
                  className={`shrink-0 w-5 h-5 text-blue-500 transition-transform duration-300 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div
                style={{
                  display: 'grid',
                  gridTemplateRows: isOpen ? '1fr' : '0fr',
                  transition: 'grid-template-rows 0.3s ease',
                }}
              >
                <div className="overflow-hidden">
                  <p className="px-6 pb-5 pt-1 text-gray-600 dark:text-gray-300 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQ;
